import { useQuery } from 'react-query'

import { defaultStaleTime } from '../../../config/queryClient'
import { QueryKeys } from '../../../enums/queryKeys'
import { fetchBankLineMatchAssociations } from '../query-api'
import { BankLineSubjectAssociationWithSubject } from '../types/bankLineSubjectAssociationWithSubject'

interface UseFetchBankLineMatchAssociationsProps {
  matchId?: string
  enabled?: boolean
}

interface UseFetchBankLineMatchAssociationsResponse {
  associations: BankLineSubjectAssociationWithSubject[]
  isLoading: boolean
}

export const useFetchBankLineMatchAssociations = ({
  matchId,
  enabled = true,
}: UseFetchBankLineMatchAssociationsProps): UseFetchBankLineMatchAssociationsResponse => {
  const { data, isLoading } = useQuery(
    [QueryKeys.BankLineMatchAssociations, matchId],
    () => fetchBankLineMatchAssociations(matchId as string),
    {
      enabled: enabled && !!matchId,
      staleTime: defaultStaleTime,
    },
  )

  return {
    associations: data?.bankLineSubjectAssociations || [],
    isLoading,
  }
}
